import AppUpdatePage from './AppUpdatePage';

export default AppUpdatePage;
